import React, { useState, useEffect } from 'react';
import Dropdown from '../../../../components/Dropdown';
import { useLazyGetTopTenPackingQuery } from '../../../../services/Api';
import LoaderSpiner from '../../../../components/loaderSpiner';
import { Pagination } from '../../../../components/Pagination';
import Modal from '../../../../components/Modal';

export default function TravelersTable() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, { data, isLoading, error }] = useLazyGetTopTenPackingQuery();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedTraveler, setSelectedTraveler] = useState(null);

  const totalPages = data?.data?.totalPages || 1;

  const handleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const openModal = (type, traveler) => {
    setModalType(type);
    setSelectedTraveler(traveler);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalType(null);
    setSelectedTraveler(null);
  };

  useEffect(() => {
    trigger({ page: currentPage });
  }, [currentPage]);

  if (isLoading) {
    return <LoaderSpiner />;
  }

  if (error) {
    return <p className="text-red-500">Error loading data. Please try again later.</p>;
  }
  console.log("data in data", data)
  const dropdownOptions = [
    { label: 'View', onClick: (e, traveler) => { e.stopPropagation(); openModal("view", traveler); } },
    { label: 'Update', onClick: (e, traveler) => { e.stopPropagation(); openModal("update", traveler); } },
    { label: 'Delete', onClick: (e, traveler) => { e.stopPropagation(); openModal("delete", traveler); } }
  ];

  return (
    <div className='overflow-x-auto' >
      <table className="w-full table-auto border-separate border-spacing-y-4">
        <thead>
          <tr className="bg-tablecolor">
            <th className="p-3 text-left w-8 rounded-l-xl">
              <input type="checkbox" className="rounded border-normalGray" />
            </th>
            <th className="p-3 text-left text-black text-sm font-['Roboto_Mono'] text-[14px] font-medium ">
              ID
            </th>
            <th className="p-3 text-left text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm">
              Traveler
            </th>
            <th className="p-3 text-left text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm">
              Destination
            </th>
            <th className="p-3 text-left text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm">
              Saved N°
            </th>
            {/* <th className="p-3 text-left w-20 rounded-r-xl text-black font-['Roboto_Mono'] text-[14px] font-medium text-sm">
              Actions
            </th> */}
          </tr>
        </thead>
        <tbody className="bg-white">
          {data?.data?.map((traveler, index) => (
            <tr
              key={index}
              className="bg-white hover:bg-tablecolor rounded-xl"
            >
              <td className="p-3 rounded-l-xl border-l border-t border-b border-solid border-bordercolor">
                <input type="checkbox" className="rounded border-gray-300" />
              </td>
              <td className="p-3 text-normalGray border-t border-b border-solid font-quicksand text-sm font-semibold border-bordercolor">{`#${traveler._id}`}</td>
              <td className="p-3 whitespace-nowrap align-middle text-normalGray font-medium text-sm border-t border-b border-solid border-bordercolor">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-white rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src="https://images.pexels.com/photos/1587009/pexels-photo-1587009.jpeg?auto=compress&cs=tinysrgb&w=600"
                      alt="Avatar"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span>{traveler?.name}</span>
                </div>
              </td>
              <td className="p-3 text-black font-quicksand font-semibold text-sm border-t border-b border-solid border-bordercolor">{traveler?.destinations?.map((item) => {
                return (
                  <>
                    {item.country && (
                      <>
                        {Array.isArray(item?.country) ? item.country.join(', ') : item?.country || ""}, <span></span>
                      </>
                    )}
                    {item.region && (
                      <>
                        {Array.isArray(item?.region) ? item.region.join(', ') : item?.region || ""}, <span></span>
                      </>
                    )}
                  </>
                )
              })}</td>
              <td className="p-3 text-normalGray  whitespace-nowrap border-t border-b font-quicksand text-sm font-semibold border-solid border-bordercolor">
                {traveler.savedByCount}
              </td>
              {/* <td className="p-3 rounded-r-xl border-r border-t border-b border-solid border-bordercolor">
                <Dropdown
                  active={activeDropdown === index}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDropdown(index);
                  }}
                  options={dropdownOptions.map((option) => ({
                    ...option,
                    onClick: (e) => option.onClick(e, traveler),
                  }))}
                />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        title={
          modalType === "view"
            ? "View Traveler"
            : modalType === "update"
              ? "Update Traveler"
              : "Delete Traveler"
        }
      >
        {modalType === "view" && (
          <div>
            <p>
              <strong>ID:</strong> #{selectedTraveler?.userId}
            </p>
            <p>
              <strong>Name:</strong> {selectedTraveler?.name}
            </p>
            <p>
              <strong>Amount:</strong> $
              {selectedTraveler?.totalPrice?.toLocaleString()}
            </p>
            <p>
              <strong>Products:</strong> {selectedTraveler?.totalItemsOrdered}{" "}
              Products
            </p>
          </div>
        )}
        {modalType === "update" && (
          <form>
            <div>
              <label>Name</label>
              <input
                type="text"
                defaultValue={selectedTraveler?.name}
                className="w-full border p-2 mt-2"
              />
            </div>
            <div className="mt-4">
              <label>Amount</label>
              <input
                type="number"
                defaultValue={selectedTraveler?.totalPrice}
                className="w-full border p-2 mt-2"
              />
            </div>
            <button className="mt-4 px-4 py-2 bg-bgprimary rounded text-black mx-auto block">
              Update
            </button>
          </form>
        )}
        {modalType === "delete" && (
          <div className="mt-4">
            <p>Are you sure you want to delete this traveler?</p>
            <button
              className="mt-4 px-4 py-2 bg-errorcolor text-white rounded"
              onClick={closeModal}
            >
              Yes, Delete
            </button>
          </div>
        )}
      </Modal>
    </div>
  );
}
